import { render, staticRenderFns } from "./Swimmingpool.vue?vue&type=template&id=80533cc2&"
import script from "./Swimmingpool.vue?vue&type=script&lang=js&"
export * from "./Swimmingpool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports